var Transaction = require('./../../../lib/saito/transaction')["default"];

/**
 * Canonical on-disk / share-link transaction format for RustScript and future consumers.
 *
 * Web serialization: { t, m, opt } — matches Transaction.serialize_to_web() /
 * deserialize_from_web() used across Saito (archive, devtools, wallet exports).
 *
 * Import also accepts legacy slip-array JSON ({ from, to, ... }) for compatibility;
 * export always uses web serialization for a lossless round-trip with import.
 */
var FORMAT_WEB = 'web';
function serializeTransactionToWeb(app, tx, options) {
  if (!tx || typeof tx.serialize_to_web !== 'function') {
    throw new Error('Transaction is required');
  }
  if (!app) {
    throw new Error('Saito app is required');
  }
  return tx.serialize_to_web(app, options);
}

/**
 * Parse transaction file text — prefers web serialization, falls back to slip-array JSON.
 */
function parseTransactionFile(app, text) {
  var raw = String(text || '').trim();
  if (!raw) {
    throw new Error('File is empty.');
  }
  var json;
  try {
    json = JSON.parse(raw);
  } catch (err) {
    throw new Error('File is not valid JSON.');
  }
  var tx;
  if (json && typeof json.t === 'string' && json.m !== undefined) {
    tx = new Transaction();
    tx.deserialize_from_web(app, raw);
  } else if (json && Array.isArray(json.from) && Array.isArray(json.to)) {
    tx = new Transaction(undefined, json);
  } else {
    throw new Error('Unrecognized transaction file format.');
  }
  var hasFrom = Array.isArray(tx.from) && tx.from.length > 0;
  var hasTo = Array.isArray(tx.to) && tx.to.length > 0;
  if (!hasFrom && !hasTo) {
    throw new Error('Transaction file could not be deserialized.');
  }
  return tx;
}
function sanitizeFilenamePart(value) {
  var maxLen = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 12;
  var text = String(value || 'unknown').replace(/[^\w.-]+/g, '');
  if (!text) {
    return 'unknown';
  }
  return text.length > maxLen ? text.slice(0, maxLen) : text;
}

/**
 * Native RustScript artifact filename (.saito).
 * - Saved scripts / drafts → rustscript-[timestamp].saito
 * - Published / signed txs → rustscript-tx-[signature].saito
 */
function transactionExportFilename(tx) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'rustscript';
  var kind = String(prefix || 'rustscript').toLowerCase();
  var isScriptDraft = kind === 'rustscript' || kind.includes('draft') || kind.includes('script');
  if (isScriptDraft && !kind.includes('published') && !kind.includes('tx')) {
    return "rustscript-".concat(Date.now(), ".saito");
  }
  var sig = sanitizeFilenamePart(tx === null || tx === void 0 ? void 0 : tx.signature, 12);
  return "rustscript-tx-".concat(sig, ".saito");
}

/**
 * Trigger a browser download of the canonical web-serialized transaction.
 * Content remains JSON; the .saito extension marks it as a RustScript artifact.
 */
function downloadTransactionFile(app, tx) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    filename = _ref.filename,
    block_id = _ref.block_id,
    transaction_id = _ref.transaction_id,
    update_outputs = _ref.update_outputs;
  var json = serializeTransactionToWeb(app, tx, {
    block_id: block_id,
    transaction_id: transaction_id,
    update_outputs: update_outputs
  });
  var name = filename || transactionExportFilename(tx);
  var blob = new Blob([json], {
    type: 'application/json'
  });
  var url = URL.createObjectURL(blob);
  var link = document.createElement('a');
  link.href = url;
  link.download = name;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
  return {
    filename: name,
    json: json
  };
}
module.exports = {
  FORMAT_WEB: FORMAT_WEB,
  serializeTransactionToWeb: serializeTransactionToWeb,
  parseTransactionFile: parseTransactionFile,
  transactionExportFilename: transactionExportFilename,
  downloadTransactionFile: downloadTransactionFile
};